import {useEffect, useState} from "react";


export const useChartSetup = (dataSeries, customSnapshotCallback) => {
    const [lastHoveredTimestamp, setLastHoveredTimestamp] = useState(null);
    const [lastHoveredPoint, setLastHoveredPoint] = useState(null);
    const [selectedRange, setSelectedRange] = useState({start: null, end: null});
    const [slidingRange, setSlidingRange] = useState({start: null, end: null});

    useEffect(() => {
        if (customSnapshotCallback) {
            customSnapshotCallback(lastHoveredPoint);
        }
    }, [lastHoveredPoint, customSnapshotCallback]);

    return {
        lastHoveredTimestamp, setLastHoveredTimestamp,
        lastHoveredPoint, setLastHoveredPoint, selectedRange, setSelectedRange, slidingRange, setSlidingRange };
};

export const useFullScreen = () => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const toggleFullScreen = () => setIsFullScreen(!isFullScreen);
    return { isFullScreen, toggleFullScreen };
};


